export { default as Root } from "./Root";
export { default as LagunaBeachside } from "./LagunaBeachside";
export { default as LagunaSeasideResidences } from "./LagunaSeasideResidences";

export { default as PhuketLagunaVillageResidences } from "./PhuketLagunaVillageResidences";
export { default as PhuketLagunaPark2 } from "./PhuketLagunaPark2";
export { default as PhuketSkypark } from "./PhuketSkypark";
export { default as PhuketDusitDeluxePoolVilla } from "./PhuketDusitDeluxePoolVilla";
export { default as PreviewTrip } from "./PreviewTrip";
export { default as Home } from "./Home";
export { default as News } from "./News";
export { default as NewsDetail } from "./News/NewsDetail";
export { default as SanctuaryClub } from "./SanctuaryClub";
export { default as AboutUs } from "./AboutUs";
export { default as ContactUs } from "./ContactUs";
export { default as NotFound } from "./NotFound";



// WEBPACK FOOTER //
// ./src/pages/index.js